import React from 'react';
import { cn } from '../../lib/utils';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  className?: string;
}

export default function StatCard({ title, value, icon: Icon, change, changeType = 'neutral', className }: StatCardProps) {
  return (
    <div className={cn('d-card-hover p-5', className)}>
      <div className="flex items-start justify-between">
        <div className="min-w-0 flex-1">
          <p className="text-sm text-slate-400 truncate">{title}</p>
          <p className="text-2xl font-bold text-white mt-1 tracking-tight">{value}</p>
          {change && (
            <p className={cn(
              'text-xs font-medium mt-1.5',
              changeType === 'positive' && 'text-emerald-400',
              changeType === 'negative' && 'text-red-400',
              changeType === 'neutral' && 'text-slate-400',
            )}>
              {change}
            </p>
          )}
        </div>
        <div className="w-10 h-10 rounded-xl bg-white/[0.04] border border-white/[0.06] flex items-center justify-center shrink-0">
          <Icon className="w-5 h-5 text-slate-400" />
        </div>
      </div>
    </div>
  );
}
